import {Compare} from '@carbon/icons-react';
import {observer} from 'mobx-react';


const CompareToggle = function() {

    return <div className={`bg-medinsight-vibrant-blue-300 rounded-3xl px-3 py-1 hover:cursor-pointer`}>
        <div className="flex space-x-2 items-center text-xs">
            <span>Compare</span>
            <Compare />
        </div>
    </div>;
};

export default observer(CompareToggle);